import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo } from '@/mocks/anime';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/riman', label: '日漫' },
    { to: '/category/hanman', label: '韩漫' },
    { to: '/category/guoman', label: '国漫' },
    { to: '/about', label: '关于我们' },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <span className="text-background-50 font-heading text-lg">51</span>
            </div>
            <span className={`font-heading text-xl transition-colors ${scrolled ? 'text-foreground-950' : 'text-background-50'}`}>
              {siteInfo.name}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive(link.to)
                    ? scrolled
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-background-50/20 text-background-50'
                    : scrolled
                      ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                      : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled ? 'text-foreground-950' : 'text-background-50'
            }`}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  isActive(link.to)
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-primary-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}